import React, { useEffect, useState, useContext } from "react";
import ToggleButton from "../../../common/ToggleButton";
import PopupModal from "../../../common/PopupModal";
import CgFormCreator from "../../../common/CgFormCreator";
import {
  fetchPracticeStatus,
  updatePracticeStatus,
  practiceDuplicateCheck,
} from "../../../store/Status/PracticeStatusActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { MyAccountContext } from "../../../App";
import rolesImage from "../../../assets/images/rolesImage.svg";

const PracticeStatus = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [resetCount, setResetCount] = useState(false);
  const [toggleKey, setToggleKey] = useState(0);
  const [statusDropdown, setStatusDropdown] = useState("");
  const [statusUpdate, setStatusUpdate] = useState();
  const [showError, setShowError] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [enableSaveBtn, setEnableSaveBtn] = useState(false);
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const [reasonSelected, setReasonSelected] = useState(null);
  const [note, setNote] = useState(null);
  const [duplicatePracticeId, setDuplicatePracticeId] = useState("");
  const [isDuplicateValid, setIsDuplicateValid] = useState(true);

  const { grantedRoles = [] } = useContext(MyAccountContext) || {};
  const isManager = grantedRoles.includes("ROLE_MANAGER");
  const isPractice = grantedRoles.includes("ROLE_PRACTICE");

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const practiceId = locationHeaderData[2];

  const dispatch = useDispatch();

  const { practiceStatusData, practiceStatusErrMsg } = useSelector(
    (state) => state.practiceStatus
  );
  const { practiceStatusUpErrMsg } = useSelector(
    (state) => state.practiceStatusUpdate
  );

  useEffect(() => {
    dispatch(fetchPracticeStatus(practiceId));
  }, []);

  useEffect(() => {
    if (practiceStatusData) {
      setStatusUpdate(practiceStatusData);
      setToggleKey((prev) => prev + 1);
      // setStatusDropdown(practiceStatusData?.isActive);
      setStatusDropdown(!practiceStatusData?.isActive ? "ON" : "OFF");
    }
  }, [practiceStatusData]);

  useEffect(() => {
    if (reasonSelected && note) {
      if (reasonSelected === "Duplicate") {
        const isValidDuplicateId = /^[A-Za-z0-9]{16}$/.test(
          duplicatePracticeId
        );
        setEnableSaveBtn(isValidDuplicateId && isDuplicateValid);
      } else {
        setEnableSaveBtn(true);
      }
      setShowValidationErrors(false);
    } else {
      setEnableSaveBtn(false);
    }
  }, [reasonSelected, note, duplicatePracticeId, isDuplicateValid]);

  useEffect(() => {
    if (openPopup) {
      setShowValidationErrors(true);
    }
  }, [openPopup]);

  useEffect(() => {
    if (practiceStatusErrMsg || practiceStatusUpErrMsg) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [practiceStatusErrMsg, practiceStatusUpErrMsg]);

  const offStatusDropdown = [
    {
      name: "Practice Sold",
      value: "Practice Sold",
    },
    {
      name: "Duplicate",
      value: "Duplicate",
    },
    {
      name: "Suppress - Practice Request",
      value: "Suppress - Practice Request",
    },
    {
      name: "No Practice at Location",
      value: "No Practice at Location",
    },
    {
      name: "Suppress - Practice Public Incident",
      value: "Suppress - Practice Public Incident",
    },
    {
      name: "Admin Office Only",
      value: "Admin Office Only",
    },
  ];

  const onStatusDropDown = [
    {
      name: "Verified",
      value: "Verified",
    },
  ];

  const formStatusSchema = [
    {
      component: "dropdown",
      name: "status",
      dropdownOptions: [
        {
          name: "ON",
          value: "ON",
        },
        {
          name: "OFF",
          value: "OFF",
        },
      ],
      required: true,
      onSelectCallBack: (name, value) => {
        setStatusDropdown(value);
      },
      defaultValue: statusDropdown,
      // defaultValue: statusUpdate?.isActive ? "ON" : "OFF",
    },
    {
      component: "dropdown",
      name: "reason",
      required: true,
      defaultValue: "",
      dropdownOptions:
        statusDropdown === "OFF" ? offStatusDropdown : onStatusDropDown,
      dropdownPlaceHolder: "Choose among the following... ",
      renderCustomError: showValidationErrors && !reasonSelected,
      onSelectCallBack: (name, value) => {
        setReasonSelected(value);
      },
    },
    ...(reasonSelected === "Duplicate"
      ? [
          {
            component: "input",
            label: "DUPLICATE OF PRACTICE ID",
            name: "duplicatePracticeId",
            type: "text",
            placeholder: "",
            required: false,
            inputProps: {
              pattern: "^[A-Za-z0-9]{16}$",
            },
            renderCustomError: !isDuplicateValid,
            className: "duplicate-field-inline",
            onKeyChangeCallback: (name, value) => {
              setDuplicatePracticeId(value);
              if (value.length === 16 && /^[A-Za-z0-9]{16}$/.test(value)) {
                dispatch(practiceDuplicateCheck(value)).then((response) => {
                  const isSuccess = response.payload.success;
                  console.log(
                    "data",
                    response.payload.data?.data?.practiceResponseDTO?.items
                  );
                  const hasItems =
                    response.payload.data?.data?.practiceResponseDTO?.items
                      ?.length > 0;
                  console.log("API Success:", isSuccess);
                  console.log("Has Items:", hasItems);
                  console.log(
                    "Items:",
                    response.payload.data?.practiceResponseDTO?.items
                  );

                  if (isSuccess && hasItems) {
                    setIsDuplicateValid(true);
                  } else {
                    setIsDuplicateValid(false);
                  }
                });
              } else {
                setIsDuplicateValid(true);
              }
            },
            valueChangeCallback: () => {},
          },
        ]
      : []),
    {
      component: "textarea",
      name: "note",
      cols: 83,
      rows: 10,
      needBorder: true,
      required: true,
      renderCustomError: showValidationErrors && !note,
      onChangeCallback: (res) => {
        console.log(res);
      },
      onKeyChangeCallback: (res) => {
        console.log(res);
        setNote(res);
      },
    },
  ];

  const RenderPracticeStatus = () => {
    return (
      <div>
        <div className="statusHeader"> YOUR STATUS </div>
        <div className="locationPopupDescWrapper">
          <div className="locationPopupDesc">
            {`These Changes will be reflected in Brighter's record`}
          </div>
          {/* <div className="locationPopupDesc">
            Please notify connecred carries of any changes to providers at your
            home
          </div> */}
        </div>
        <div
          className={`statusWrapper ${
            reasonSelected === "Duplicate" ? "duplicate-field-active" : ""
          }`}
        >
          <CgFormCreator
            key={resetCount}
            enablePrimaryBtn={enableSaveBtn}
            schema={formStatusSchema}
            onSubmitCallback={(val) => {
              const payload = {
                isActive: val.status == "ON" ? "true" : "false",
                reasonCode: val.reason,
                note: val.note,
              };
              if (reasonSelected === "Duplicate" && duplicatePracticeId) {
                payload.duplicateOfEntityId = duplicatePracticeId;
              }
              dispatch(
                updatePracticeStatus({
                  practiceId: practiceId,
                  data: payload,
                })
              ).then(() => {
                dispatch(fetchPracticeStatus(practiceId));
                setToggleKey((prev) => prev + 1);
              });
              setOpenPopup(!openPopup);
            }}
            onCancel={() => {
              setResetCount(!resetCount);
              setOpenPopup(!openPopup);
            }}
          />
        </div>
      </div>
    );
  };

  const RenderPopup = () => {
    return (
      <div>
        <PopupModal
          isOpen={openPopup}
          onClose={() => {
            setOpenPopup(!openPopup);
            setReasonSelected(null);
            setNote(null);
            setDuplicatePracticeId("");
            setIsDuplicateValid(true);
            // setStatusDropdown(statusUpdate?.isActive);
            setStatusDropdown(!statusUpdate?.isActive ? "ON" : "OFF");
            setShowValidationErrors(false);
            setResetCount(!resetCount);
          }}
          width="50%"
          customRender={RenderPracticeStatus}
        />
      </div>
    );
  };

  const RenderProviderStatusError = () => {
    if (!showError) return null;
    return (
      <div className="overlay-alert alert alert-danger" role="alert">
        {practiceStatusErrMsg || practiceStatusUpErrMsg}
      </div>
    );
  };

  return (
    <>
      <div>
        {statusUpdate &&
          (isManager || isPractice ? (
            <div className="toggle-container" key={toggleKey}>
              <span className="toggleLabel">STATUS: </span>
              <span>{statusUpdate?.isActive ? "ON" : "OFF"}</span>
              {!statusUpdate?.isActive && (
                <div className="tooltip-container">
                  <img
                    src={rolesImage}
                    alt="Manager Role"
                    className="tooltip-icon"
                    onClick={() => setShowTooltip(!showTooltip)}
                  />
                  <div
                    className={`tooltip-content ${showTooltip ? "show" : ""}`}
                  >
                    {statusUpdate?.isActive ? "Active" : "Inactive"}
                    {statusUpdate?.isDisplayedOnSite === "false"
                      ? " - Not Displayed On Site"
                      : ""}
                    : {statusUpdate?.reason}
                    <br />
                    {statusUpdate?.note}
                    <br />
                    <br />
                    updated {statusUpdate?.date} by {statusUpdate?.username}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <ToggleButton
              key={toggleKey}
              customToggleStyle
              statusUpdate={statusUpdate}
              defaultValue={
                statusUpdate?.isDisplayOnsite
                  ? statusUpdate?.isActive
                    ? true
                    : false
                  : false
              }
              onChangeCallback={() => {
                // const status = statusUpdate?.isDisplayOnsite ? "OFF" : "ON";
                // setStatusDropdown(status);
                // setEditItem(statusUpdate);
                setOpenPopup(!openPopup);
              }}
            />
          ))}
      </div>
      {!isManager && !isPractice && RenderPopup()}
      {RenderProviderStatusError()}
    </>
  );
};
export default PracticeStatus;
